import type { SourceItem } from '../types';

const GLOBAL_REGION = 'Global';

/** Returns true if the source's regions overlap with the user's mapped regions or Global. */
export function isRegionMatch(source: SourceItem, userRegions: string[]): boolean {
  if (source.regions.length === 0) return false;
  const targets = userRegions.map((r) => r.toLowerCase());
  return source.regions.some(
    (r) =>
      r === GLOBAL_REGION || targets.some((target) => r.toLowerCase().includes(target))
  );
}
